import { createRoute, useNavigate } from "@tanstack/react-router";
import { Leaderboard, ReviewDesk } from "@/features/review";
import { rootRoute } from "./root";

export const reviewLeaderboardRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/review/leaderboard",
  component: function ReviewLeaderboard() {
    const navigate = useNavigate();
    return (
      <ReviewDesk>
        <Leaderboard onBack={() => navigate({ to: "/review" })} />
      </ReviewDesk>
    );
  },
});
